<div class="container h-100 d-flex align-items-center" *ngIf="!aiAgents || isLoading">
    <mat-spinner [diameter]="90" [strokeWidth]="3" class="mx-auto"></mat-spinner>
</div>

<div class="container p-5" *ngIf="aiAgents">
    <div class="row">
        <div class="col-12 d-flex justify-content-end">
            <button mat-raised-button extended (click)="onCreateAssistant()">
                <mat-icon>person_add_alt</mat-icon>
                Create Assistant
            </button>
        </div>
    </div>

    <ng-container *ngIf="aiAgents.length > 0">
        <!-- Filter -->
        <div class="row">
            <div class="col-12">
                <mat-form-field appearance="fill" class="w-100 mt-5">
                    <mat-label>Filter By name</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Mia" #input>
                    <mat-icon matPrefix>search</mat-icon>
                </mat-form-field>
            </div>
        </div>

        <!-- List of assistants -->

        <div class="row">
            <ng-container *ngFor="let agent of filteredAgents">
                <div class="col-lg-4 col-md-6 col-sm-12 col-12 p-3">
                    <div class="d-flex flex-column justify-content-around mat-elevation-z2 mt-2 mb-2 rounded p-3">
                        <div class="d-flex align-items-center justify-content-center">
                            <mat-icon class="example-tab-icon me-1 mb-2">support_agent</mat-icon>
                            <p class="fw-bold text-decoration-underline">{{agent.name}}</p>
                        </div>
                        <p class="text-center">{{capitalizeFirstLetter(agent.agentType)}}</p>
                        <button class="mt-4" mat-raised-button (click)="onEditAssistant(agent)">Open</button>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>

    <h1 class="fw-light text-center mt-5" *ngIf="aiAgents.length == 0">Click create assistant to add one</h1>
</div>